module.exports = __webpack_public_path__ + "static/media/centro_platea_1(1).c3f0c8a3.jpg";